module.exports = __webpack_public_path__ + "img/ubuntu.25258772.jpg";